import { mergeAttributes, Node } from '@tiptap/core'

// Matches Redmine resource link patterns (not preceded by '!'):
//   document#17, version:1.0.0, r758 (commit), source:path/to/file,
//   forum#2, news#1, project:name, message#5
const RESOURCE_REF_RE
  = /(?<=\s|^)((?:document|forum|news|message|version|project)(?:#\d+|:[^\s,;.!?)\]]+)|r\d+|source:[^\s,;.!?)\]]+)(?=[\s,;.!?)\]]|$)/gm

export const ResourceRef = Node.create({
  name: 'redmineResourceRef',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      raw: { default: '' },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-resource-ref]',
        getAttrs: el => ({
          raw: el.getAttribute('data-resource-ref') || el.textContent || '',
        }),
      },
    ]
  },

  renderHTML({ node }) {
    return [
      'span',
      mergeAttributes({
        'data-resource-ref': node.attrs.raw,
        'class': 'resource-ref-node',
      }),
      node.attrs.raw,
    ]
  },

  renderMarkdown({ node }) {
    return node.attrs.raw
  },

  markdownTokenName: 'redmineResourceRef',

  markdownTokenizer: {
    name: 'redmineResourceRef',
    level: 'inline',
    start: (src) => {
      // Find earliest match among all patterns
      RESOURCE_REF_RE.lastIndex = 0
      const m = RESOURCE_REF_RE.exec(src)
      if (!m)
        return -1
      return m.index
    },
    tokenize: (src) => {
      RESOURCE_REF_RE.lastIndex = 0
      const m = RESOURCE_REF_RE.exec(src)
      if (!m)
        return
      return {
        type: 'redmineResourceRef',
        raw: m[0],
        ref: m[1],
        tokens: [],
      } as any
    },
  },

  parseMarkdown(token) {
    return {
      type: 'redmineResourceRef',
      attrs: { raw: (token as any).ref ?? '' },
    }
  },
})
